import { RoadmapPhase } from '../types';

// Token Contract Address from .env
export const CA_ADDRESS = import.meta.env.VITE_DUCK_TOKEN_ADDRESS || "0x0862F464c8457266b66c58F1D7C1137B72647777";

// Nad.fun Token Page URL from .env
export const NADFUN_TOKEN_URL = import.meta.env.VITE_NADFUN_TOKEN_URL || "https://nad.fun/tokens/0x0862F464c8457266b66c58F1D7C1137B72647777";

// Explorer URL
export const EXPLORER_URL = import.meta.env.VITE_EXPLORER_URL || "https://monadscan.com";

// Social Links from .env
export const SOCIAL_LINKS = {
    twitter: import.meta.env.VITE_TWITTER_URL || "https://twitter.com/0xdockmon",
    telegram: import.meta.env.VITE_TELEGRAM_URL || "https://t.me/+TRF2KXd5jdE4ZGU0",
    nadfun: NADFUN_TOKEN_URL,
};

// Token image from nadapp storage
export const TOKEN_IMAGE_URL = "https://storage.nadapp.net/coin/c15fd59c-ea36-4b3a-9c47-80dd396a2645";

export const TOKEN_INFO = {
    name: "DUCK",
    symbol: "$DUCK",
    description: "The most unhinged aquatic bird on the Monad network. Born in the ponds of nad.fun.",
    tagline: "QUACK!",
    imageUrl: TOKEN_IMAGE_URL,
};

export const ROADMAP_DATA: RoadmapPhase[] = [
    {
        title: "Phase 1: The Hatching",
        items: [
            "Launch on nad.fun",
            "Community Formation",
            "First 1,000 Holders",
            "Website Launch"
        ],
        status: 'completed'
    },
    {
        title: "Phase 2: Learning to Fly",
        items: [
            "Coingecko Listing",
            "Trending on Monad",
            "Community Growth",
            "5,000 Holders"
        ],
        status: 'current'
    },
    {
        title: "Phase 3: Migration",
        items: [
            "CEX Listings",
            "Duck NFT Collection",
            "Global Marketing Campaign",
            "To The Moon (or Pond)"
        ],
        status: 'upcoming'
    }
];

// Tokenomics data for pie chart
export const TOKENOMICS_DATA = [
    { name: 'Liquidity Pool', value: 90, fill: '#22c55e' },
    { name: 'Development', value: 5, fill: '#836EF9' },
    { name: 'Marketing', value: 5, fill: '#FFD700' },
];
